<div class="emp-list">

    <!-- Toolbar -->
    <div class="table-actions-toolbar">
        <button class="btn-advanced-sort"
                (click)="openSortModal()"
                title="Advanced Search & Sort (All Columns)"
                [class.has-active-filters]="getActiveSortCount() > 0">
            <mat-icon>tune</mat-icon>
            <span class="button-text">Filters</span>
            <span class="filter-badge" *ngIf="getActiveSortCount() > 0">{{ getActiveSortCount() }}</span>
        </button>

        <button class="btn-clear-all"
                (click)="clearAllSorts()"
                *ngIf="getActiveSortCount() > 0"
                title="Clear all filters and sorts">
            <mat-icon>close</mat-icon>
            Clear
        </button>

        <!-- Column visibility picker -->
        <div class="col-picker-wrap">
            <button class="btn-col-picker"
                    (click)="openColumnEditor(); $event.stopPropagation()"
                    [class.active]="columnSelectionOpen"
                    title="Edit columns">
                <mat-icon>view_column</mat-icon>
                <span class="button-text">Columns</span>
                <mat-icon style="margin-left: 0.25rem;">keyboard_arrow_down</mat-icon>
            </button>
        </div>

        <!-- Edit Column slide-in panel (rendered outside toolbar so it can overlay table) -->
        <div class="col-editor-overlay" *ngIf="columnSelectionOpen" (click)="closeColumnEditor()"></div>
        <div class="col-editor-panel" *ngIf="columnSelectionOpen" (click)="$event.stopPropagation()">

            <!-- Panel header -->
            <div class="col-editor-header">
                <span class="col-editor-title">Edit Column</span>
                <button class="col-editor-close" (click)="closeColumnEditor()" title="Close">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- Body: left checklist + right reorder list -->
            <div class="col-editor-body">

                <!-- LEFT: search + checkbox list -->
                <div class="col-editor-left">
                    <!-- Count badge -->
                    <div class="col-editor-count">{{ selectedCount }} of {{ totalPickable }} selected</div>

                    <!-- Search -->
                    <div class="col-editor-search-wrap">
                        <input class="col-editor-search"
                               type="text"
                               [(ngModel)]="colSearchTerm"
                               placeholder="Search columns..." />
                        <mat-icon class="col-editor-search-icon">search</mat-icon>
                    </div>

                    <!-- Select all -->
                    <ul class="col-check-list">
                        <li class="col-check-item col-check-item--selectall">
                            <label class="col-check-label">
                                <input type="checkbox"
                                       [checked]="allChecked"
                                       [indeterminate]="someChecked"
                                       (change)="toggleSelectAll($any($event.target).checked)" />
                                <span class="col-check-selectall-text">[Select all]</span>
                            </label>
                        </li>
                        <li class="col-check-item" *ngFor="let header of filteredDraftHeaders">
                            <label class="col-check-label">
                                <input type="checkbox"
                                       [checked]="header._checked"
                                       (change)="toggleDraftColumn(header)" />
                                <span>{{ header.headerName }}</span>
                            </label>
                        </li>
                    </ul>
                </div>

                <!-- Divider -->
                <div class="col-editor-divider"></div>

                <!-- RIGHT: drag-to-reorder selected columns -->
                <div class="col-editor-right">
                    <ul class="col-order-list">
                        <li class="col-order-item"
                            *ngFor="let header of selectedOrderList; let i = index"
                            draggable="true"
                            (dragstart)="onDragStart(i)"
                            (dragover)="onDragOver($event, i)"
                            (dragend)="onDragEnd()">
                            <span class="col-order-drag">
                                <mat-icon>drag_indicator</mat-icon>
                            </span>
                            <span class="col-order-name">{{ header.headerName }}</span>
                            <button class="col-order-remove" (click)="removeFromSelected(header)" title="Remove">
                                <mat-icon>close</mat-icon>
                            </button>
                        </li>
                    </ul>
                </div>

            </div>

            <!-- Footer: Apply / Cancel -->
            <div class="col-editor-footer">
                <button class="btn-col-apply" (click)="applyColumnSelection()">Apply</button>
                <button class="btn-col-cancel" (click)="closeColumnEditor()">Cancel</button>
            </div>

        </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
        <table class="table table-sortable">
            <thead>
                <tr>
                    <th *ngFor="let header of visibleHeaders"
                        [class.sortable]="header.type !== 'checkbox' && header.type !== 'actions'"
                        [class.sorted]="isSorted(header.entityName)"
                        (click)="header.type !== 'checkbox' && header.type !== 'actions' && sort(header.entityName)">

                        <!-- Checkbox: select-all -->
                        <label *ngIf="header.type === 'checkbox'" class="th-check-label">
                            <input type="checkbox"
                                   (change)="selectAll($event)"
                                   [checked]="isAllSelected"
                                   (click)="$event.stopPropagation()" />
                        </label>

                        <!-- Regular column -->
                        <div *ngIf="header.type !== 'checkbox'" class="th-inner">
                            <span class="header-text" [class.header-text--active]="isSorted(header.entityName)">
                                {{ header.headerName }}
                            </span>
                            <!-- Stacked sort arrows for non-action columns -->
                            <span *ngIf="header.type !== 'actions'" class="sort-arrows">
                                <mat-icon [class.arrow-active]="isSorted(header.entityName) && !reverse">keyboard_arrow_up</mat-icon>
                                <mat-icon [class.arrow-active]="isSorted(header.entityName) && reverse">keyboard_arrow_down</mat-icon>
                            </span>
                            <!-- Per-column search -->
                            <button *ngIf="header.type !== 'actions'"
                                    class="btn-column-search"
                                    [class.active]="isSorted(header.entityName)"
                                    (click)="openColumnSearch(header); $event.stopPropagation()"
                                    [title]="'Filter ' + header.headerName">
                                <mat-icon>search</mat-icon>
                                <span *ngIf="getSortPriority(header.entityName) > 0" class="column-priority-badge">
                                    {{ getSortPriority(header.entityName) }}
                                </span>
                            </button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of dataArray | paginate: { id: 'listing_pagination', itemsPerPage: itemsPerPage, currentPage: page }; let i = index"
                    [class.row-selected]="data?.selected">
                    <td *ngFor="let header of visibleHeaders">

                        <span *ngIf="header.type === 'text'">{{ getColumnValue(header, data) }}</span>

                        <span *ngIf="header.type === 'date'">{{ getColumnValue(header, data) | date: dateFormats.DISPLAY_FORMAT : dateFormats.LOCALE }}</span>

                        <span *ngIf="header.type === 'shortDate'">{{ getColumnValue(header, data) | date: dateFormats.DISPLAY_FORMAT : dateFormats.LOCALE }}</span>

                        <span *ngIf="header.type === 'currency'">{{ getColumnValue(header, data) | currency }}</span>

                        <ng-container *ngIf="header.type === 'text-id'">
                            <ng-container *ngFor="let conf of lookupData[header.lookUpValue]">
                                <span *ngIf="conf[header.key] == getColumnValue(header, data)">{{ conf[header.value] }}</span>
                            </ng-container>
                        </ng-container>

                        <a *ngIf="header.type === 'link'" class="table-link">
                            {{ getColumnValue(header, data) }}
                        </a>

                        <a *ngIf="header.type === 'route'" class="table-link" (click)="edit(data, header.type, header.entityName)">
                            {{ getColumnValue(header, data) }}
                        </a>

                        <a *ngIf="header.visible && header.type === 'label-link'" class="table-link"
                           (click)="routeToAnotherPage(header.routeData, data)">
                            {{ getColumnValue(header, data) }}
                        </a>

                        <ng-container *ngIf="header.type === 'text-id-route'">
                            <ng-container *ngFor="let conf of lookupData[header.lookUpValue]">
                                <a *ngIf="conf[header.key] == getColumnValue(header, data)"
                                   class="table-link" (click)="edit(data, header.type, header.entityName)">
                                    {{ conf[header.value] }}
                                </a>
                            </ng-container>
                        </ng-container>

                        <a *ngIf="header.type === 'downloadLink'" class="table-link" (click)="openFile(data)">
                            {{ getColumnValue(header, data) }}
                        </a>

                        <button *ngIf="header.type === 'button'" class="btn-tbl-secondary"
                                (click)="openFile(data)" type="button">
                            <mat-icon>visibility</mat-icon>
                            View
                        </button>

                        <button *ngIf="header.type === 'actions'" class="btn-row-action" (click)="edit(data, header.type, header.entityName)" type="button" title="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button *ngIf="header.type === 'transfer'" class="btn-tbl-secondary"
                                (click)="edit(data, header.type, header.entityName)" type="button">
                            {{ header.entityName }}
                        </button>

                        <button *ngIf="header.type === 'reupload'" class="btn-tbl-secondary"
                                (click)="edit(data, header.type, header.entityName)" type="button">
                            Re-upload
                        </button>

                        <input *ngIf="header.type === 'checkbox'" type="checkbox"
                                class="tbl-checkbox"
                                [(ngModel)]="data.selected"
                                (change)="onCheckboxChange(i, $event)" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Empty state -->
    <div class="tbl-empty" *ngIf="isLoader && dataArray.length === 0">
        <mat-icon>inbox</mat-icon>
        <span>No records found</span>
    </div>

    <!-- Footer: rows-per-page left � pagination right -->
    <div class="tbl-footer" *ngIf="isLoader && dataArray.length !== 0">
        <div class="tbl-footer__left">
            <span class="footer-label">Rows per page</span>
            <select class="rows-select" [ngModel]="itemsPerPage" (ngModelChange)="changePageSize($event)">
                <option [value]="10">10</option>
                <option [value]="25">25</option>
                <option [value]="50">50</option>
                <option [value]="100">100</option>
            </select>
            <span class="footer-label">of {{ dataArray.length }} rows</span>
        </div>
        <div class="tbl-footer__right">
            <pagination-controls
                id="listing_pagination"
                [maxSize]="5"
                [directionLinks]="true"
                previousLabel="� Prev"
                nextLabel="Next �"
                (pageChange)="page = $event">
            </pagination-controls>
        </div>
    </div>
</div>